<template>
    <div>
        <div class="formTitle flex" style="justify-content: space-between;">
            <span>客运监管</span>
            <el-button v-if="!edit" type="text" @click="editSupervise" style="font-size: 14px;">编辑</el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="196px" :disabled="!edit">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="能源类型" prop="energyType">
                        <el-select v-model="form.energyType" filterable>
                            <el-option label="汽油" value="1"></el-option>
                            <el-option label="柴油" value="2"></el-option>
                            <el-option label="天然气" value="3"></el-option>
                            <el-option label="液化气" value="4"></el-option>
                            <el-option label="电动" value="5"></el-option>
                            <el-option label="双燃料" value="6"></el-option>
                            <el-option label="氢" value="7"></el-option>
                            <el-option label="双燃料CNG" value="8"></el-option>
                            <el-option label="其他" value="9"></el-option>
                            <el-option label="双燃料LNG" value="10"></el-option>
                            <el-option label="单燃料CNG" value="11"></el-option>
                            <el-option label="单燃料LNG" value="12"></el-option>
                            <el-option label="混合动力" value="14"></el-option>
                            <el-option label="甲醇" value="16"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="车辆品牌" prop="brand">
                        <el-input style="width: 100%" type="text" placeholder="请输入车辆品牌(同行驶证)" maxlength="20"
                            v-model="form.brand"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="车辆型号" prop="motorcycleType">
                        <el-input type="text" placeholder="请输入车辆型号(同行驶证)" maxlength="20"
                            v-model="form.motorcycleType"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="年审日期" prop="inspectAnnuallyDate">
                        <el-date-picker style="width: 100%" v-model="form.inspectAnnuallyDate" type="date"
                            value-format="timestamp" placeholder="请选择年审日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="车辆注册日期" prop="licenseRegDate">
                        <el-date-picker style="width: 100%" v-model="form.licenseRegDate" type="date"
                            value-format="timestamp" placeholder="请选择车辆注册日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="道路运输证号" prop="transportCertsNumber">
                        <el-input style="width: 100%" type="text" placeholder="请输入道路运输证号" maxlength="30"
                            v-model="form.transportCertsNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="道路运输证业户名称" prop="transportCertsOwner">
                        <el-input style="width: 100%" type="text" placeholder="请输入道路运输证业户名称" maxlength="50"
                            v-model="form.transportCertsOwner"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="加入平台时间" prop="platformJoiningDate">
                        <el-date-picker style="width: 100%" v-model="form.platformJoiningDate" type="date"
                            value-format="timestamp" placeholder="请选择加入平台时间">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="是否有灭火器" prop="hasExtinguishers">
                        <el-radio-group v-model="form.hasExtinguishers">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="2">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否有安全锤" prop="hasHammer">
                        <el-radio-group v-model="form.hasHammer">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="2">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="是否有移动式安检设备" prop="hasSecurityDevice">
                        <el-radio-group v-model="form.hasSecurityDevice">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="2">无</el-radio>
                        </el-radio-group>
                    </el-form-item>

                </el-col>
                <el-col :span="12">
                    <el-form-item label="道路运输证经营" prop="businessScope">
                        <el-select v-model="form.businessScope" filterable placeholder="请选择道路运输证经营">
                            <el-option label="省际班车客运" value="01104"></el-option>
                            <el-option label="省际包车客运" value="01204"></el-option>
                            <el-option label="市际班车客运" value="01103"></el-option>
                            <el-option label="市际包车客运" value="01203"></el-option>
                            <el-option label="县际班车客运" value="01102"></el-option>
                            <el-option label="县际包车客运" value="01202"></el-option>
                            <el-option label="县内班车客运" value="01101"></el-option>
                            <el-option label="县内包车客运" value="01201"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>




            <el-row :gutter="24">
                <el-col :span="12">

                    <el-form-item label="车辆类型等级" prop="technicalLevel">
                        <el-select v-model="form.technicalLevel" filterable placeholder="请选择车辆类型等级">
                            <el-option label="乘用车-高级" value="51"></el-option>
                            <el-option label="乘用车-中级" value="53"></el-option>
                            <el-option label="小型客车-高二级" value="41"></el-option>
                            <el-option label="小型客车-高一级" value="42"></el-option>
                            <el-option label="小型客车-中级" value="43"></el-option>
                            <el-option label="小型客车-普通级" value="44"></el-option>
                            <el-option label="中型客车-高二级" value="31"></el-option>
                            <el-option label="中型客车-高一级" value="32"></el-option>
                            <el-option label="中型客车-中级" value="33"></el-option>
                            <el-option label="中型客车-普通级" value="34"></el-option>
                            <el-option label="大型客车-高三级" value="21"></el-option>
                            <el-option label="大型客车-高二级" value="22"></el-option>
                            <el-option label="大型客车-高一级" value="23"></el-option>
                            <el-option label="大型客车-中级" value="24"></el-option>
                            <el-option label="大型客车-普通级" value="25"></el-option>
                            <el-option label="其他" value="9"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="定制客运标志牌号" prop="signsNumber">
                        <el-input style="width: 100%" type="text" placeholder="请输入定制客运标志牌号" maxlength="20"
                            v-model="form.signsNumber"></el-input>
                    </el-form-item>

                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="定制客运标志牌日期起" prop="signsDateStart">
                        <el-date-picker style="width: 100%" v-model="form.signsDateStart" type="date"
                            value-format="timestamp" placeholder="请选择定制客运标志牌日期起">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="定制客运标志牌日期止" prop="signsDateEnd">
                        <el-date-picker style="width: 100%" v-model="form.signsDateEnd" type="date"
                            value-format="timestamp" placeholder="请选择有定制客运标志牌日期止">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="承运人责任险pdf文件" prop="insurePdf">
                        <upload_pdfs :max="1" @update:urls="updateUrls" :urls.sync="form.insurePdf">
                        </upload_pdfs>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="承运人责任险保险公司全称" prop="insureCompany">
                        <el-input style="width: 100%" type="text" placeholder="请输入承运人责任险保险公司全称(与保单一致)" maxlength="50"
                            v-model="form.insureCompany"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="保险起日期" prop="dateOfInsureStart">
                        <el-date-picker style="width: 100%" v-model="form.dateOfInsureStart" type="date"
                            value-format="timestamp" placeholder="请选择保险起日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="保险止日期" prop="dateOfInsureEnd">
                        <el-date-picker style="width: 100%" v-model="form.dateOfInsureEnd" type="date"
                            value-format="timestamp" placeholder="请选择保险止日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="所有制" prop="ownership">
                        <el-radio-group v-model="form.ownership">
                            <el-radio :label="1">公车公营</el-radio>
                            <el-radio :label="2">承包经营</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>


        </el-form>

        <div v-if="edit" style="text-align: right; margin-bottom: 16px;">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="onsubmit">确 定</el-button>
        </div>
    </div>
</template>

<script>
import upload_pdfs from "@/components/pdf/upload_pdfs";

export default {
    name: "supervise",
    components: {
        upload_pdfs
    },
    data() {
        return {
            edit: false,
            form: {
                energyType: "",
                brand: "",
                motorcycleType: "",
                inspectAnnuallyDate: "",
                licenseRegDate: "",
                transportCertsNumber: "",
                transportCertsOwner: "",
                platformJoiningDate: "",
                hasExtinguishers: '',
                hasHammer: '',
                hasSecurityDevice: '',

                businessScope: '',
                technicalLevel: '',
                signsNumber: '',
                insurePdf: [],
                insureCompany: '',
                dateOfInsureStart: '',
                dateOfInsureEnd: '',
                ownership: 1,
            },
            rules: {
                energyType: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
                brand: [{ required: true, message: '请输入车辆品牌', trigger: ['blur', 'change'] }],
                motorcycleType: [{ required: true, message: '请输入车辆型号', trigger: ['blur', 'change'] }],
                inspectAnnuallyDate: [{ required: true, message: '请选择年审日期', trigger: ['blur', 'change'] }],
                licenseRegDate: [{ required: true, message: '请选择车辆注册日期', trigger: ['blur', 'change'] }],

                transportCertsNumber: [{ required: true, message: '请输入道路运输证号', trigger: ['blur', 'change'] }],
                transportCertsOwner: [{ required: true, message: '请输入道路运输证业户名称', trigger: ['blur', 'change'] }],
                platformJoiningDate: [{ required: true, message: '请选择加入平台时间', trigger: ['blur', 'change'] }],
                // hasExtinguishers: [{required: true, message: '是否有灭火器', trigger: ['blur', 'change']}],
                // hasHammer: [{required: true, message: '是否有安全锤', trigger: ['blur', 'change']}],
                ownership: [{ required: true, message: '请选择所有制', trigger: ['blur', 'change'] }],
                // hasSecurityDevice: [{required: true, message: '是否有移动式安检设备', trigger: ['blur', 'change']}],

                businessScope: [{ required: true, message: '请选择道路运输证经营', trigger: ['blur', 'change'] }],
                technicalLevel: [{ required: true, message: '请选择车辆类型等级', trigger: ['blur', 'change'] }],
                signsNumber: [{ required: true, message: '请输入定制客运标志牌号', trigger: ['blur', 'change'] }],


                signsDateStart: [{ required: true, message: '请选择定制客运标志牌日期起', trigger: ['blur', 'change'] }],
                signsDateEnd: [{ required: true, message: '请选择有定制客运标志牌日期止', trigger: ['blur', 'change'] },
                {
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请选择有效期止'))
                        } else if (value <= this.form.signsDateStart) {
                            callback(new Error('终止日期请大于起始日期!'))
                        } else {
                            callback()
                        }
                    },
                    trigger: ['blur', 'change']
                }],
                insurePdf: [{ required: true, message: '请上传承运人责任险pdf文件', trigger: ['blur', 'change'] }],
                insureCompany: [{
                    required: true,
                    message: '请输入承运人责任险保险公司全称(与保单一致)',
                    trigger: ['blur', 'change']
                }],
                dateOfInsureStart: [{ required: true, message: '请选择保险起日期', trigger: ['blur', 'change'] }],
                dateOfInsureEnd: [{ required: true, message: '请选择保险止日期', trigger: ['blur', 'change'] },
                {
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请选择有效期止'))
                        } else if (value <= this.form.dateOfInsureStart) {
                            callback(new Error('终止日期请大于起始日期!'))
                        } else {
                            callback()
                        }
                    },
                    trigger: ['blur', 'change']
                }],

            }
        }
    },
    props: {
        vehicleId: {
            default: ''
        }
    },
    created() {
        this.getInitMerchantFn()
    },
    methods: {
        editSupervise() {
            this.edit = true
        },
        async getInitMerchantFn() {
            const { code, data } = await this.$axios.get('/api/v1/manage/vehicle/survey', {
                vehicleId: this.vehicleId
            })
            if (code === 1 && data) {
                this.form = {
                    ...this.form,
                    ...data,
                    inspectAnnuallyDate: new Date(data.inspectAnnuallyDate).getTime(),
                    licenseRegDate: new Date(data.licenseRegDate).getTime(),
                    platformJoiningDate: new Date(data.platformJoiningDate).getTime(),
                    signsDateStart: new Date(data.signsDateStart).getTime(),
                    signsDateEnd: new Date(data.signsDateEnd).getTime(),
                    dateOfInsureStart: new Date(data.dateOfInsureStart).getTime(),
                    dateOfInsureEnd: new Date(data.dateOfInsureEnd).getTime(),
                    insurePdf: [{ url: data.insurePdf, name: data.insurePdf }]
                }
            }
        },
        updateUrls() {
            this.$refs.form.validateField('insurePdf')
        },
        handleClose() {
            this.form = {
                energyType: "",
                brand: "",
                motorcycleType: "",
                inspectAnnuallyDate: "",
                licenseRegDate: "",
                transportCertsNumber: "",
                transportCertsOwner: "",
                platformJoiningDate: "",
                hasExtinguishers: '',
                hasHammer: '',
                hasSecurityDevice: '',

                businessScope: '',
                technicalLevel: '',
                signsNumber: '',
                insurePdf: [],
                insureCompany: '',
                dateOfInsureStart: '',
                dateOfInsureEnd: '',
            }
            this.edit = false
        },
        onsubmit() {
            console.log(this.form, 111);
            console.log(this.vehicleId);
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    const url = '/api/v1/manage/vehicle/survey'
                    const params = {
                        ...this.form,
                        vehicleId: this.vehicleId,
                        insurePdf: this.form.insurePdf[0].url,
                        inspectAnnuallyDate: this.$utils.timeFn(this.form.inspectAnnuallyDate, 'YYYY-MM-DD'),
                        licenseRegDate: this.$utils.timeFn(this.form.licenseRegDate, 'YYYY-MM-DD'),
                        platformJoiningDate: this.$utils.timeFn(this.form.platformJoiningDate, 'YYYY-MM-DD'),
                        signsDateStart: this.$utils.timeFn(this.form.signsDateStart, 'YYYY-MM-DD'),
                        signsDateEnd: this.$utils.timeFn(this.form.signsDateEnd, 'YYYY-MM-DD'),
                        dateOfInsureStart: this.$utils.timeFn(this.form.dateOfInsureStart, 'YYYY-MM-DD'),
                        dateOfInsureEnd: this.$utils.timeFn(this.form.dateOfInsureEnd, 'YYYY-MM-DD'),
                    }
                    const { code } = await this.$axios.post(url, params)
                    if (code === 1) {
                        this.$message.success('操作成功')
                        this.edit = false
                    }
                } else {
                    this.$message.warning("请检查表单数据是否输入正确！");
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped></style>